var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusDisableErrorGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0003 9C16.0003 5.93 14.3603 3.36 11.5003 2.68V2C11.5003 1.17 10.8303 0.5 10.0003 0.5C9.17027 0.5 8.50027 1.17 8.50027 2V2.68C5.63027 3.36 4.00027 5.92 4.00027 9V14L2.00027 16V17H18.0003V16L16.0003 14V9ZM4.15027 0.65L5.58027 2.08C3.54027 3.53 2.18027 5.85 2.03027 8.5H0.0302734C0.170273 5.3 1.75027 2.48 4.15027 0.65ZM19.9703 8.5H17.9703C17.8203 5.85 16.4503 3.53 14.4303 2.08L15.8503 0.65C18.2403 2.48 19.8203 5.3 19.9703 8.5ZM10.4003 19.96C10.2703 19.99 10.1403 20 10.0003 20C8.89027 20 8.00027 19.1 7.99027 18H11.9903C11.9903 18.28 11.9403 18.54 11.8403 18.78C11.5803 19.38 11.0503 19.82 10.4003 19.96Z",
    fill: "#727E84"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDisableErrorGrey);
export default __webpack_public_path__ + "static/media/status_disable_error_grey.fba9e0099e09a2468445ec3efa8b9ee9.svg";
export { ForwardRef as ReactComponent };